import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";
import { MetricTimeRange } from "../../components/Dashboard/types/dashboardTypes";

// Redux state stores dates as ISO strings for serialization
export interface DashboardState {
  metricTimeRange: {
    startDate: string; // ISO string
    endDate: string; // ISO string
  };
  /** Company admin: null = all stores. Store-scoped roles ignore this (backend uses JWT). */
  dashboardStoreId: string | null;
}

/** Inclusive last 7 calendar days through now (matches DateRangeSelector “Last 7 Days”). */
function defaultMetricTimeRangeIso(): DashboardState["metricTimeRange"] {
  const end = new Date();
  return {
    startDate: subDays(end, 6).toISOString(),
    endDate: end.toISOString()
  };
}

export const initialDashboardState: DashboardState = {
  metricTimeRange: defaultMetricTimeRangeIso(),
  dashboardStoreId: null
};

export const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState: initialDashboardState,
  reducers: {
    setMetricTimeRange: (state, action: PayloadAction<MetricTimeRange>) => {
      // Convert Date objects to ISO strings for Redux state
      state.metricTimeRange = {
        startDate: action.payload.startDate.toISOString(),
        endDate: action.payload.endDate.toISOString()
      };
    },
    resetMetricTimeRange: (state) => {
      state.metricTimeRange = defaultMetricTimeRangeIso();
    },
    setDashboardStoreId: (state, action: PayloadAction<string | null>) => {
      state.dashboardStoreId = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setMetricTimeRange, resetMetricTimeRange, setDashboardStoreId } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
